module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin.component.scss
// module id = ./src/app/components/admin/admin.component.scss
// module chunks = main